function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "@neru/ui";
import { useCallback, useState } from "react";
import { IconWrapper, Image, Wrapper } from "./styles";
export var AVATAR_SHAPES;
(function(AVATAR_SHAPES) {
    AVATAR_SHAPES["circle"] = "circle";
    AVATAR_SHAPES["rounded"] = "rounded";
    AVATAR_SHAPES["square"] = "square";
})(AVATAR_SHAPES || (AVATAR_SHAPES = {}));
export var AVATAR_SIZES;
(function(AVATAR_SIZES) {
    AVATAR_SIZES[AVATAR_SIZES["large"] = 64] = "large";
    AVATAR_SIZES[AVATAR_SIZES["medium"] = 48] = "medium";
    AVATAR_SIZES[AVATAR_SIZES["small"] = 32] = "small";
})(AVATAR_SIZES || (AVATAR_SIZES = {}));
export var Avatar = function(param) {
    var _param_border = param.border, border = _param_border === void 0 ? false : _param_border, fallbackImage = param.fallbackImage, iconType = param.iconType, _param_shape = param.shape, shape = _param_shape === void 0 ? "rounded" : _param_shape, _param_size = param.size, size = _param_size === void 0 ? 48 : _param_size, src = param.src, _param_title = param.title, title = _param_title === void 0 ? "Avatar" : _param_title;
    var _useState = _sliced_to_array(useState(0), 2), backOff = _useState[0], setBackOff = _useState[1];
    var errorFallback = useCallback(function(e) {
        if (backOff < (fallbackImage ? 2 : 1)) {
            e.currentTarget.src = fallbackImage !== null && fallbackImage !== void 0 ? fallbackImage : "".concat(import.meta.env.VITE_PUBLIC_URL, "/img/no-image.png");
            setBackOff(backOff + 1);
        }
    }, [
        backOff,
        fallbackImage
    ]);
    if (src) {
        return /*#__PURE__*/ _jsx(Wrapper, {
            "data-testid": "avatar",
            shape: shape,
            size: size,
            children: /*#__PURE__*/ _jsx(Image, {
                alt: title,
                "data-testid": "image-".concat(title),
                onError: errorFallback,
                src: src
            })
        });
    }
    return /*#__PURE__*/ _jsx(IconWrapper, {
        border: border,
        "data-testid": "avatar",
        shape: shape,
        size: size,
        children: /*#__PURE__*/ _jsx(Icon, {
            customSize: size,
            type: iconType !== null && iconType !== void 0 ? iconType : "puzzle-line"
        })
    });
};

//# sourceMappingURL=Avatar.js.map